<div class="settings">
  <dt-select [(selectedOptions)]="evaluationMode">
    <dt-select-label i18n>Auswertungsmethode</dt-select-label>
    <dt-select-option value="default" i18n>Standard</dt-select-option>
    <dt-select-option value="consensus" i18n>Konsensabweichung</dt-select-option>
  </dt-select>

  <dt-select-line>
    @if (evaluationMode === 'default') {
      <dt-select [(selectedOptions)]="shownMembers" [multiple]="true">
        <dt-select-label i18n>Mitglieder</dt-select-label>
        @for (member of team.members; track member; let memberIndex = $index) {
          @if (graphData.members[memberIndex].valid) {
            <dt-select-option [value]="memberIndex"><dt-team-member-name [member]="member"></dt-team-member-name></dt-select-option>
          }
        }
      </dt-select>
    }
    @if (evaluationMode === 'consensus') {
      <dt-select [(selectedOptions)]="consensusCount" (selectedOptionsChange)="groupMemberIndexesByWeights(objectiveNames.length)">
        <dt-select-label i18n>Abweichungen</dt-select-label>
        <dt-select-option [value]="1" [disabled]="membersWithValidProjects < 1">1</dt-select-option>
        <dt-select-option [value]="2" [disabled]="membersWithValidProjects < 2">2</dt-select-option>
        <dt-select-option [value]="3" [disabled]="membersWithValidProjects < 3">3</dt-select-option>
        <dt-select-option [value]="4" [disabled]="membersWithValidProjects < 4">4</dt-select-option>
      </dt-select>
    }
    <dt-select [(selectedOptions)]="showAverage">
      <dt-select-label i18n>Mittelwert anzeigen</dt-select-label>
      <dt-select-option value="none" i18n>Keiner</dt-select-option>
      <dt-select-option value="weighted" i18n>Gewichtet</dt-select-option>
      <dt-select-option value="unweighted" i18n>Ungewichtet</dt-select-option>
      <dt-select-option value="both" i18n>Beide</dt-select-option>
    </dt-select>
  </dt-select-line>
</div>
<div class="members">
  @if (evaluationMode === 'default') {
    @for (member of team.members; track member; let memberIndex = $index) {
      @if (shownMembers.includes(memberIndex) && graphData.members[memberIndex].valid) {
        <div class="member" (mouseenter)="hoveringLine = memberIndex" (mouseleave)="hoveringLine = -1">
          <dt-team-member-name [member]="member"></dt-team-member-name>
        </div>
      }
    }
  }

  @if (showAverage === 'both' || showAverage === 'weighted') {
    <div class="member aggregate" (mouseenter)="hoveringLine = 'weighted'" (mouseleave)="hoveringLine = -1" i18n
      >Gewichteter Mittelwert</div
    >
  }
  @if (showAverage === 'both' || showAverage === 'unweighted') {
    <div class="member aggregate unweighted" (mouseenter)="hoveringLine = 'unweighted'" (mouseleave)="hoveringLine = -1" i18n
      >Ungewichteter Mittelwert</div
    >
  }
</div>
<div class="graph-holder">
  <div class="graph-container">
    <div class="utility-label" i18n>Zielgewichte</div>
    <div class="y-scale">
      @for (v of yScale; track v) {
        <span>{{ v }}</span>
      }
    </div>
    <div class="vertical-seperator"></div>
    <div class="graph-overlay grid-background vertical" [style.background-size]="gridBackground"> </div>
    <div class="graph-overlay grid-background horizontal" [style.background-size]="gridBackground"> </div>

    <div class="graph-overlay">
      @for (member of graphData.members; track member; let i = $index; let last = $last) {
        @if (shownMembers.includes(i) && evaluationMode === 'default' && member.valid) {
          <svg
            class="graph-overlay line-overlay-container"
            [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== i"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <path [attr.d]="member.line"></path>
          </svg>
        }
      }

      @if (showAverage === 'both' || showAverage === 'weighted') {
        <svg
          class="graph-overlay line-overlay-container average"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'weighted'"
        >
          <path [attr.d]="graphData.averages.weighted.line"></path>
        </svg>
        <svg
          class="graph-overlay line-overlay-container average second"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'weighted'"
        >
          <path [attr.d]="graphData.averages.weighted.line"></path>
        </svg>
      }

      @if (showAverage === 'both' || showAverage === 'unweighted') {
        <svg
          class="graph-overlay line-overlay-container average unweighted"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'unweighted'"
        >
          <path [attr.d]="graphData.averages.unweighted.line"></path>
        </svg>
        <svg
          class="graph-overlay line-overlay-container average unweighted second"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== 'unweighted'"
        >
          <path [attr.d]="graphData.averages.unweighted.line"></path>
        </svg>
      }
    </div>

    @if (evaluationMode === 'default') {
      <div class="graph-overlay">
        @for (member of graphData.members; track member; let projectIndex = $index) {
          @if (shownMembers.includes(projectIndex) && member.valid) {
            <div class="graph-overlay member-dot-container">
              @for (vertex of member.vertices; track vertex) {
                <div
                  [style.left.%]="vertex[0]"
                  [style.top.%]="vertex[1]"
                  class="member-dot"
                  [class.grayed-out]="hoveringLine !== -1 && hoveringLine !== projectIndex"
                ></div>
              }
            </div>
          }
        }
      </div>
    }

    @if (hoveringLine !== -1) {
      <div class="graph-overlay">
        @if (!isNumber(hoveringLine)) {
          @for (vertex of graphData.averages[hoveringLine].vertices; track vertex) {
            <div [style.left.%]="vertex[0]" [style.top.%]="vertex[1]" class="member-value">{{
              graphPositionToOriginalValue(vertex[1]) / 100 | percent: '1.1-1'
            }}</div>
          }
        }
        @if (isNumber(hoveringLine)) {
          @for (vertex of graphData.members[hoveringLine].vertices; track vertex) {
            <div [style.left.%]="vertex[0]" [style.top.%]="vertex[1]" class="member-value">{{
              graphPositionToOriginalValue(vertex[1]) / 100 | percent: '1.1-1'
            }}</div>
          }
        }
      </div>
    }

    @if (evaluationMode === 'consensus') {
      <div class="graph-overlay clickable">
        @for (_ of objectiveNames; track _; let objectiveIndex = $index) {
          @for (group of memberIndexesGroupedByFurthestValues[objectiveIndex]; track group; let groupIndex = $index) {
            <div
              [style.left.%]="group.vertices[0]"
              [style.top.%]="group.vertices[1]"
              class="consensus-circle"
              [dtHoverPopover]="memberInfo"
              [dtHoverPopoverPosition]="groupIndex % 2 === 0 ? 'left' : 'right'"
            ></div>

            <ng-template #memberInfo>
              <div class="member-info">
                @for (memberIndex of group.memberIndexes; track memberIndex) {
                  <div class="member-name"> <dt-team-member-name [member]="team.members[memberIndex]"></dt-team-member-name>, </div>
                }
                <div class="member-weight">{{ group.rounded }}%</div>
              </div>
            </ng-template>
          }
        }
      </div>
    }

    <div class="horizontal-seperator"></div>
    <div
      class="x-label-container"
      [style.width.%]="100 + 100 / (objectiveNames.length - 1)"
      [style.transform]="'translateX(-' + 100 / objectiveNames.length / 2 + '%)'"
    >
      @for (objectiveName of objectiveNames; track objectiveName; let objectiveIndex = $index) {
        <div
          class="x-label"
          [style.grid-column]="4 + objectiveIndex"
          [matTooltip]="objectiveName"
          #tooltip="matTooltip"
          [dtOverflow]
          [dtOverflowTooltip]="tooltip"
          (mouseenter)="trigger(objectiveIndex)"
        >
          {{ objectiveName }}
        </div>
      }
    </div>
    <div class="x-axis-label" i18n>Ziele</div>
  </div>
</div>
